import { render } from "./OptionboardPhonemicConsonant.vue?vue&type=template&id=3cca9a64&scoped=true"
import script from "./OptionboardPhonemicConsonant.vue?vue&type=script&lang=js"
export * from "./OptionboardPhonemicConsonant.vue?vue&type=script&lang=js"

import "@/css/components/optionboard-phonemic-consonant.css?vue&type=style&index=0&id=3cca9a64&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cca9a64"]])

export default __exports__